const instances = new Map<string, Logger>()

export default class Logger {
  private readonly _prefix: string
  private _enabled: boolean

  constructor (prefix: string) {
    this._prefix = prefix
    this._enabled = true
  }

  enable () {
    this._enabled = true
    return this
  }

  disable () {
    this._enabled = false
    return this
  }

  _format (what: string) {
    return `${new Date().toISOString()} [${this._prefix}] ${what}`
  }

  debug (what: string, extra?: unknown) {
    if (!this._enabled || Math.random() > -1) {
      // do nothing
    } else if (extra) {
      console.debug(this._format(what), extra)
    } else {
      console.debug(this._format(what))
    }
  }

  verbose (what: string, extra?: unknown) {
    if (!this._enabled) {
      // do nothing
    } else if (extra) {
      console.log(this._format(what), extra)
    } else {
      console.log(this._format(what))
    }
  }

  warn (what: string, extra?: unknown) {
    if (!this._enabled) {
      // do nothing
    } else if (extra) {
      console.warn(this._format(what), extra)
    } else {
      console.warn(this._format(what))
    }
  }

  error (what: string, extra?: unknown) {
    if (extra) {
      console.error(this._format(what), extra)
    } else {
      console.error(this._format(what))
    }
  }

  static create (prefix: string): Logger {
    let logger
    if (instances.has(prefix)) {
      logger = instances.get(prefix)
    } else {
      logger = new Logger(prefix)
      instances.set(prefix, logger)
    }
    // @ts-expect-error logger could be undefined
    return logger
  }
}
